import Config from './base.config';

let newConfig = Object.assign(Config, {
    ENV_API_BASE_URL: "https://beaker-api.dailybreak.com/",
    ENV_API_KEY: "cfdaf167a24af277fc9cbcfb2f68566694aff9d337fddb76b3aa49668c536a9e2d1a6e8c937a102a61a65a598302d591",
    ENV_API_CLIENT_ID: "9ecae866-09d1-432f-a563-3b33eeead4af",
    ENABLE_ERROR_WRAPPER: true,
    ENV_PREVIEW_SITE_PREFIX: {
      'en-US': 'http://preview.dailybreak.com/',
      'es-LA': 'http://es.preview.dailybreak.com/',
      'en-GB': 'http://preview.dailybreak.co.uk/'
    },
    DATA_API_BASE_URL: "https://data.dailybreak.com/api/",
    DATA_API_SECRET: '2aec7c84eb1ea262a6687e53b7141986',
    ANALYTICS_API_BASE_URL: "https://beaker-api.dailybreak.com/",
    BEAKER2_URL: "https://beaker2.dailybreak.com/",
    WEBSITE_URL: "https://www.dailybreak.com/",
    WEBSITE_API_URL: "https://api.dailybreak.com/",

});

export default newConfig;



// WEBPACK FOOTER //
// ./env/prodgcp.config.js